import React from 'react';
import { Hero } from './components/Hero';
import { TestimonialStrip } from './components/TestimonialStrip';
import { Problema } from './components/Problema';
import { Tomos } from './components/Tomos';
import { Bonos } from './components/Bonos';
import { Oferta } from './components/Oferta';
import { SistemaTotal } from './components/SistemaTotal';
import { Testimonios } from './components/Testimonios';
import { CostoDeNoTenerlo } from './components/CostoDeNoTenerlo';
import { Garantia } from './components/Garantia';
import { Faq } from './components/Faq';
import { CierreFinal } from './components/CierreFinal';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="w-full bg-forest-900 font-sans" data-id="element-0" data-mp="2wip734ny5m5z">
      <Hero data-id="element-1" data-mp="28tmfb3zlmcxr" />
      <main data-id="element-2" data-mp="28te3lff7pdo5">
        <TestimonialStrip data-id="element-3" data-mp="28suu8n3mnxlq" />
        <Problema data-id="element-4" data-mp="28s2xva27hvue" />
        <Tomos data-id="element-5" data-mp="23vkw8j26adma" />
        <Bonos data-id="element-6" data-mp="23vulg4fe8gqx" />
        <Oferta data-id="element-7" data-mp="23u9vyt7xrnzx" />
        <SistemaTotal data-id="element-8" data-mp="23ut9zyugts8o" />
        <Testimonios data-id="element-9" data-mp="23ti8k5ohswkq" />
        <CostoDeNoTenerlo data-id="element-10" data-mp="3ik7eyd5x05p2" />
        <Garantia data-id="element-11" data-mp="3iiwf2oflbi38" />
        <Faq data-id="element-12" data-mp="3ijfvg0pldyf5" />
        <CierreFinal data-id="element-13" data-mp="3ihv22ef0kliv" />
      </main>
      <Footer data-id="element-14" data-mp="3mlaxj7fckftz" />
      <PurchasePopup data-id="element-15" data-mp="3mkrbpfmkt7ao" />
    </div>;
}